package com.example.monetix.db

import kotlin.Boolean
import kotlin.Long
import kotlin.String

public data class PiggyBankEntity(
  public val id: String,
  public val name: String,
  public val accumulatedCents: Long,
  public val emoji: String,
  public val colorHex: String,
  public val imageUri: String?,
  public val isDeleted: Boolean,
  public val createdAtEpochMs: Long,
  public val updatedAtEpochMs: Long,
)
